import cx from "classnames";
import { Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconLock from "../../assets/images/icons/lock.svg?react";
import "./TaskCard.css";

const TaskCard = (props) => {
    const {
        title, icon: Icon, children,
        isSuccess, isWarning,
        isLocked, isDisabled,
        showArrow, onTitleClick,
        className,
        isPrimary,
    } = props;

    const HeaderComponent = onTitleClick ? "button" : "div";

    return (
        <div
            className={cx(
                "task-card",
                { "task-card--success": isSuccess },
                { "task-card--warning": isWarning },
                { "task-card--locked": isLocked },
                { "task-card--disabled": isDisabled },
                { "task-card--primary": isPrimary },
                className,
            )}
        >
            <HeaderComponent className="task-card__header" onClick={onTitleClick}>
                <Typography variant="h4" className="task-card__title">
                    {title}
                </Typography>
                {isLocked && <span className="task-card__lock"><IconLock /></span>}
                {showArrow && <span className="task-card__arrow"><ChevronRightIcon /></span>}
                {(!isLocked && Icon) && <span className="task-card__icon"><Icon /></span>}
            </HeaderComponent>
            <div className="task-card__content">
                {children}
            </div>
        </div>
    );
};

export default TaskCard;
